import { useEffect } from "react";
import { ClientOverviewRepositoryImpl } from "../../data/repositories/ClientOverviewRepositoryImpl";
import { GetClientOverviewBootstrapUseCase } from "../../domain/use-cases/GetClientOverviewBootstrapUseCase";
import {
  getClientOverviewBootstrapData,
  getClientOverviewBootstrapError,
  getClientOverviewBootstrapPromise,
  setClientOverviewBootstrapData,
  setClientOverviewBootstrapError,
  setClientOverviewBootstrapPromise,
} from "../state/clientOverviewBootstrapStore";

const repository = new ClientOverviewRepositoryImpl();
const useCase = new GetClientOverviewBootstrapUseCase(repository);

export function useClientOverviewBootstrap(): void {
  useEffect(() => {
    if (getClientOverviewBootstrapData() || getClientOverviewBootstrapError()) {
      return;
    }

    if (!getClientOverviewBootstrapPromise()) {
      const promise = useCase.execute();
      setClientOverviewBootstrapPromise(promise);
      promise
        .then((entity) => {
          setClientOverviewBootstrapError(null);
          setClientOverviewBootstrapData(entity);
        })
        .catch((err) => {
          const message =
            err instanceof Error ? err.message : "Failed to load overview bootstrap";
          setClientOverviewBootstrapError(message);
        })
        .finally(() => {
          setClientOverviewBootstrapPromise(null);
        });
    }
  }, []);
}
